angular.module('aprima-patient-api', [
    'restangular',
    'angularLocalStorage',
    'lodash',

    //aprima
    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common'
]);
angular.module('aprima-patient-api').value('GuidList', {
    'FeatureList': {'ViewClinicalSummary': '27d5a4b8-1c68-45bb-a89f-023fbc5fc370',
        'Problems': 'c7f48f12-cea2-45a2-b6c3-bf69f404d624',
        'ViewMedications': 'c7f48f12-cea2-45a2-b6c3-bf69f404d624',
        'ViewProcedures': '937a64e0-1c2a-42ab-ab29-877e8555f812',
        'ViewImmunizations': '0354d96b-e135-4753-b06c-1634e6745299',
        'ViewLabTestResults': '217ea966-914f-4036-9d97-b8d0f69ba1a4',
        'ViewEducationMaterial': 'aaad592b-0bff-4141-9f1c-504786cfe873',
        'UpdateDemographics': 'db28aa45-8e4e-4646-bd98-332c718ace12',
        'UpdateInsurance': '349cdc7a-781c-4586-8414-12f79b1b6d1d',
        'ViewMedicationAllergies': '49d7f6a3-546f-4b90-8237-7573328cb324',
        'ViewMedicalHistory': '7ec64d3e-e5b1-40c8-a61d-8aaa1f92e312',
        'RequestRxRefills': 'b77f8f32-2d6a-4c67-bcb1-c5040cf5a7d7',
        'ViewCompleteChart': 'aa04ca02-089b-4455-8566-cf9d766487b6',
        'RequestAppointments': 'ec14ccd3-e629-458d-8ff0-0bcfa932a1be',
        'ResetPasswordFromLogin': 'e4374e8f-c437-4fed-9f56-28bf780d49a6',
        'ViewPatientStatement': '27fd1c02-42b7-441c-8b2a-4998a1aa1762',
        'SendReceiveMessages': '5b780e05-5dcc-44de-a617-52d7f4a118d8',
        'ViewAppointments': '19a6fc42-14a5-4df8-91fc-60ed9be714c7',
        'CheckIn': '3ae462ed-a97c-4681-97c8-8e901b08f331',
        'ViewPatientLedger': 'd092edc0-32fa-42a5-b14f-b4bb6c3fc1bd',
        'RequestAssistanceFromLogin': '91c6168b-afc4-4964-87a4-e8e3fc6a960c',
        'MakeAPayment': 'a3978397-4796-43b3-9586-7f24e41aee33',
        'AllowGenerateCCD': '74763879-aa19-4cc5-a309-9517471903fa',
        'PatientMessageAttachment' : '25c3a27d-a63c-4198-b94b-eaa75cb045b3',
        'ViewDocuments' : '73187c49-163c-4c71-8133-151539dd9dfe'
        },
        'VaccineAdminList': {
          'Adult': '187D09C3-F59F-446F-AF14-3D8E1A3BD920',
          'Pediatric': '6B1B35B9-85A8-499E-83D9-11EBB24CEA04'
        },
    'MessageSubType':{
        'PatientAttachment': 'd8799ae1-d76c-4def-b7cd-1d89955a7446' //Attachment Approval
    }
});